
import * as React from 'react';
import {
  IItemsViewLayoutHandler,
  IItemsViewLayoutProps,
  itemsViewLayoutHandlerControl
} from '../../../controls/itemsViewBetaControl';
import { detailsLayoutType, compactDetailsLayoutType } from '../../layouts/DetailsLayoutTypeFacet';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { asAsync } from '../../../utilities/components/Async';
import CommandStrings from '../../commands/Commands.resx';
import { withItemSetSelection } from '../../decorators/connectToSelection';
import {
  IDetailsListProps
} from 'office-ui-fabric-react/lib/DetailsList';
import { withPageLoadTracker } from '../../decorators/withPageLoadTracker';
import { injectProps } from '../../../utilities/components/Props';
import { withSelectedItemsContextMenu } from '../../decorators/withSelectedItemsContextMenu';

const AsyncDetailsList = asAsync(async () => (
  await import(/* webpackChunkName: 'itemsetdetailslist' */'../../itemSetDetailsList/ItemSetDetailsList')
).ItemSetDetailsList);

const ContextMenuDetailsList = withSelectedItemsContextMenu()(AsyncDetailsList);

const AsyncDetailsListWithSelection = withItemSetSelection()(ContextMenuDetailsList);

const PageLoadDetailsList = withPageLoadTracker([])(AsyncDetailsListWithSelection);

class LayoutDetailsList extends React.PureComponent<IItemsViewLayoutProps> {
  public render(): JSX.Element {
    return (
      <PageLoadDetailsList { ...this.props } />
    );
  }
}

const PageLoadCompactDetailsList = injectProps((): Pick<IDetailsListProps, 'compact'> => {
  return {
    compact: true
  };
})(PageLoadDetailsList);

class LayoutCompactDetailsList extends React.PureComponent<IItemsViewLayoutProps> {
  public render(): JSX.Element {
    return (
      <PageLoadCompactDetailsList { ...this.props } />
    );
  }
}

export const itemsViewDetailsLayoutHandler: IItemsViewLayoutHandler = {
  key: detailsLayoutType.id,
  command: {
    automationId: 'detailsListCommand',
    name: CommandStrings.ViewList,
    title: CommandStrings.ViewListCommandTooltip,
    iconProps: {
      iconName: 'list'
    }
  },
  controlHandler: (
    itemCache: IItemCache,
    props: typeof itemsViewLayoutHandlerControl.inputType
  ): typeof itemsViewLayoutHandlerControl.returnType => {
    return {
      layout: LayoutDetailsList
    };
  }
};

export const itemsViewCompactDetailsLayoutHandler: IItemsViewLayoutHandler = {
  key: compactDetailsLayoutType.id,
  command: {
    automationId: 'compactDetailsListCommand',
    name: CommandStrings.ViewCompactList,
    title: CommandStrings.ViewCompactListCommandTooltip,
    iconProps: {
      iconName: 'alignleft'
    }
  },
  controlHandler: (
    itemCache: IItemCache,
    props: typeof itemsViewLayoutHandlerControl.inputType
  ): typeof itemsViewLayoutHandlerControl.returnType => {
    return {
      layout: LayoutCompactDetailsList
    };
  }
};
